export enum PotType {
  PURCHASE = 'PURCHASE',
  GRANT = 'GRANT',
  FREE = 'FREE',
  INCLUDED = 'INCLUDED',
  PAYG = 'PAYG',
  ADJUSTMENT = 'ADJUSTMENT',
}

export interface PotBalance {
  type: PotType;
  used: number;
  remaining: number;
  total: number;
  expiry_date: string;
}

export interface UsageBalanceResponse {
  pots: PotBalance[];
  total_credits_consumed: number;
  total_credits_charged: number;
  total_credits_remaining: number;
  billing_cycle_start: string;
  billing_cycle_end: string;
}

export interface UsageTransaction {
  timestamp: string;
  user_email: string;
  access_type: string;
  credits_billed: number;
}

export interface UsageTransactionsResponse {
  transactions: UsageTransaction[];
  total_count: number;
  limit: number;
  offset: number;
}
